import { createFileRoute, redirect } from '@tanstack/react-router'
import { AccountingRegisterScreen } from '@/features/accounting-bank/register-screen'
import { hasGrant } from '@/lib/me'

export const Route = createFileRoute('/_authenticated/accounting/accounts/$accountId/register')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_account.view'))
      throw redirect({ to: '/accounting' })
  },
  component: RegisterRoute,
})

function RegisterRoute() {
  const { accountId } = Route.useParams()
  return <AccountingRegisterScreen accountId={accountId} />
}
